enum LoginStatus {
    PENDING = 'statusPending',
    SUCCESS = 'statusSuccess',
    FAILED = 'statusFailed'
}

export default LoginStatus
